<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">QUOTES</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createQuote">Create Quote</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="quotes.columns" :data="quotes.data">
                    <template slot="table-row" v-if="quotes.data.length">
                        <tr v-for="(item, index) in quotes.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.author}}</td>
                            <td>{{item.quote}}</td>
                            <td>{{item.csvCorporationName}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewQuote(item)" v-tooltip.top-center="quotes.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editQuote(item)" v-tooltip.top-center="quotes.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const quotesColumns = ['Author', 'Quote','Corporations', 'Status', 'Operations'];
    export default {
        name: 'quotes',
        components: {
            LTable,
        },
        data() {
        return {
              quotes: {
                tooltips: {
                    view: 'View Quote',
                    edit: 'Edit Quote',
                    delete: 'Inactivate Quote',
                    activate:'Activate Quote',
                },
                columns: [...quotesColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchQuotes () {
            this.$store.dispatch('FETCH_QUOTES')
                    .then((res) => {
                        this.quotes.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewQuote(quote){
            this.$router.push({ name: 'QuoteDetail', params: { id: quote.quoteId}})
        },
        editQuote(quote){
            this.$router.push({ name: 'EditQuote', params: { id: quote.quoteId}})
        },
        createQuote(){
            this.$router.push({ name: 'CreateQuote'})
        },
        deleteTestimonial(testimonial, boolean){
            console.log("testimonial : ", testimonial);
            this.$store.dispatch('DELETE_SELECTED_TESTIMONIAL', {testimonialId: testimonial.pkCarouselId})
                    .then((res) => {
                        console.log("DELETE_SELECTED_EXPERT API res : ", res);
                        this.fetchTestimonials();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_EXPERT API error : ", err);
                    })
        }
    },
    created() {
        this.fetchQuotes();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Quotes/Quotes.vue